module.exports = __webpack_public_path__ + "static/media/21ECLAC25.65723afa.jpg";